import angular from 'angular';

/* Component Imports */
import { TSeriesActivityFeed, TSeriesMiniMap } from './t-series-activity-feed/activity-feed.component';
import TSeriesInventory from './t-series-inventory/inventory.component';
/* Controller Imports */
import TSeriesDashboardController from './dashboard.controller';
import TSeriesUtilizationController from './t-series-utilization/utilization.controller';
import TSeriesVerficationController from './t-series-verification/verification.controller';
/* Directive Imports */
import TSeriesUtilizationDirective from './t-series-utilization/utilization.directive';
import TSeriesVerificationDirective from './t-series-verification/verification.directive';
/* Service Imports */
import TSeriesRouteConfig from './t-series.route';
import TSeriesService from './dashboard.service';

const tSeriesModule = angular.module('app.tSeries', [
    "ui.bootstrap",
    "ui.router",
    "gettext"
])
/* Components */
.directive('tSeriesActivityFeed', TSeriesActivityFeed)
.directive('tSeriesMiniMap', TSeriesMiniMap)
.directive('tSeriesInventory', TSeriesInventory)
/* Controllers */
.controller('TSeriesDashboardController', TSeriesDashboardController)
.controller('TSeriesUtilizationController', TSeriesUtilizationController)
.controller('TSeriesVerficationController', TSeriesVerficationController)
/* Directives */
.directive('tseriesUtilizationComponent', TSeriesUtilizationDirective)
.directive('tseriesVerficationComponent', TSeriesVerificationDirective)
/* Services */
.config(TSeriesRouteConfig)
.service('TSeriesService', TSeriesService);

export default tSeriesModule.name;